import React, { ComponentProps } from "react";
import { Box, Flex, Text, Badge, Button, openIntercom } from "@thenounproject/lingo-core";
import styled from "styled-components";
import UpsellTooltip from "../../../components/spaces/settings/UpsellTooltip";

interface Props {
  title: string;
  upgradeRequired?: boolean;
  customizationMessage?: string;
  children: React.ReactNode;
  upgradeBadge?: {
    featureName: string;
    openUpgradeModal: () => void;
    plural?: boolean;
    direction?: ComponentProps<typeof UpsellTooltip>["direction"];
  };
}

const Wrapper = styled(Flex).attrs({
  flexDirection: "column",
})``;
const Title = styled(Flex).attrs({ alignItems: "center", mb: "xs" })``;

const OptionWrapper = styled(Box).attrs({ width: "100%" })<Pick<Props, "upgradeRequired">>`
  ${props =>
    props.upgradeRequired &&
    `
    opacity: .5;
    pointer-events: none;
    user-select: none;
  `}
`;

const ThemeEditorOption: React.FC<Props> = ({
  children,
  title,
  customizationMessage,
  upgradeBadge,
}) => {
  return (
    <Wrapper>
      <Title>
        <Text font="ui.smallBold" color="black" mr="s">
          {title}
        </Text>
        {upgradeBadge && (
          <Box data-tooltip-source={`${title}-upgrade-tooltip`}>
            <UpsellTooltip
              source={`${title}-upgrade-tooltip`}
              onClick={upgradeBadge.openUpgradeModal}
              featureName={upgradeBadge.featureName}
              plural={upgradeBadge.plural}
              direction={upgradeBadge.direction}
            />
            <Badge id={title} text="Upgrade" />
          </Box>
        )}
      </Title>
      <OptionWrapper upgradeRequired={Boolean(upgradeBadge)}>{children}</OptionWrapper>
      {customizationMessage && (
        <Flex gap="0.25em" flexWrap="wrap">
          <Button
            text="Contact us"
            size="small"
            buttonStyle="tertiary"
            onClick={() => openIntercom()}
          />
          <Text font="ui.small" color="grayDarkest">
            {customizationMessage}
          </Text>
        </Flex>
      )}
    </Wrapper>
  );
};

export default ThemeEditorOption;
